import { render } from "./Customer.vue?vue&type=template&id=74e5a912"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"
script.render = render

export default script